import axios from 'axios';
import { requestInterceptor, responseInterceptor } from './interceptor';
import { API, NODE_ENV } from '@/config';
import { i18n } from '@/i18n.js';

export const api = axios.create({
  baseURL: API.BASE_URL,
  timeout: NODE_ENV === 'production' ? API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': i18n.locale,
  },
});

api.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
);

api.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
);

export default api;
